import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

/**
 * Bar Ball marker fragment for Indoor Football.
 * This indicates the kickoff hit the goalpost (bar ball).
 * This is a marker fragment - the actual recovery details come from subsequent fragments.
 */
export default class BarBall extends Fragment {
    constructor() {
        super();
        this.code = "BB";
    }

    summarize() {
        return new FragmentSummary("hit goalpost");
    }

    updateSummaryContext() {
        // No context updates needed - just a marker
    }

    toJSON() {
        return {
            ...super.toJSON()
        };
    }
}
